export const transformTabName = (tabName) => {
    const tabNameArray = tabName?.split('/');
    const transformedTabName = `/new_${tabNameArray?.[1]}`;

    return tabNameArray?.[0] + transformedTabName;
};

export const appendSectionToTabName = (tabName, section) => {
    const transformedSection = section ? `_${section}` : '';

    return tabName + transformedSection;
};

export const getAppName = (brand: string) => (brand === 'se' ? 'wms' : brand);

export const capitalizeText = (text: string): string =>
  text
    .split(' ')
    .map((word) => {
        return word[0].toUpperCase() + word.substring(1);
    })
    .join(' ');
